import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core';
import { MultilineFormatter } from './multiline-formatter';

@Component({
    selector: 'multiline',
    template: require('./multiline.component.html'),
    styles: [require('./multiline.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultilineComponent implements OnChanges {

    @Input()
    public value: string;

    public values: string[];

    public constructor(private multilineFormatter: MultilineFormatter) { }

    public ngOnChanges() {
        this.values = this.multilineFormatter.format(this.value);
    }
}